import Lookup from 'src/componentes/select2';

const StatusModeloAvaliacao = ({ ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/StatusModeloAvaliacaoLookup"
    clearable={false}
    {...rest}
  />
);

export default StatusModeloAvaliacao;
